import * as React from "react";
import LoginPopup from "../generic/loginPopup";
// import DeviceContext from "../../components/service/indentifyDevice";
import DeviceContext from "../../../services/indentifyDevice";

import {
  ELoginPopupState,
  urls,
} from "../../../Containers/Client/Login/loginConstants";
import LoginStatus from "../generic/loginStatus";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface ILoginStatusScreenProps {
  popupState: ELoginPopupState;
  message?: string;
  onLinkClick?: () => void;
  onButtonClick?: () => void;
  onClose?: () => void;
  title?: string;
}

const LoginStatusScreen: React.FC<ILoginStatusScreenProps> = (props) => {
  let status = <></>;

  switch (props.popupState) {
    case ELoginPopupState.LOGINID_SENT:
      status = (
        <LoginStatus
          className="inactive_account"
          color="blue"
          icon="edel-icon-tick"
          title={props.title ? props.title : "Communication Sent"}
          linkTxt="Okay"
          link={urls.login}
          message={props.message}
        />
      );
      break;

    case ELoginPopupState.EMAIL_SENT:
      status = (
        <LoginStatus
          className="inactive_account"
          color="blue"
          icon="edel-icon-tick"
          title={props.title ? props.title : "Email Sent"}
          linkTxt="Okay"
          link={urls.login}
          message={props.message}
        />
      );
      break;
    case ELoginPopupState.PASSWORD_UPDATE:
      status = (
        <LoginStatus
          className="inactive_account"
          color="blue"
          icon="edel-icon-tick"
          title={props.message}
          linkTxt="Go to login?"
          link={urls.login}
        />
      );
      break;

    case ELoginPopupState.OPEN_ACC_SUCC:
      status = (
        <LoginStatus
          color="green"
          icon="edel-icon-tick"
          title="Received Request"
          linkTxt="Okay"
          onLinkClick={props.onLinkClick}
          message={props.message}
        />
      );
      break;
  }

  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      onClose={props.onClose}
      className="login_sts"
    >
      {status}
    </LoginPopup>
  );
};

export default LoginStatusScreen;
